import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UserService } from 'src/app/core/common-services/user.services';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { Router } from '@angular/router';
import { FundDataService } from 'src/app/core/data-services/fund/fund.data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { EFundStatus, FundTypeEnum, OpportunityItemDto } from 'src/app/core/data-models/opportunity.data.models';
import { AppTheme, TenantConfigService } from 'src/app/shared/services/tenant-config.service';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  companyName: string = '';
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'determinate';
  opportunities: OpportunityItemDto[] = [];
  filterFundStatus: EFundStatus = EFundStatus.Current;
  filterFundType?: FundTypeEnum ;
  fundStatus = EFundStatus;
  fundTypes = FundTypeEnum;
  homeMobileAppSplashImageUrl?:string;
  coloredLogoUrl?:string;
  opportunityTheme: AppTheme=AppTheme.CLASSIC;
  opportunityThemes=AppTheme;
  @ViewChild('filterDialogRef') filterDialogRef!: TemplateRef<any>;
  tenantId:string='';
  selectedFilterFundStatus: EFundStatus = EFundStatus.Current;
  googlePlayDownloadUrl:string='';
  appleStoreDownloadUrl:string='';
  emptyStateImageUrl?: string;
  constructor(
    private router: Router,
    private tenantConfigService: TenantConfigService,
    private fundDataService: FundDataService,
    private notificationService: NotificationService,
    public languageService: LanguageService,
    private dialogService: DialogService,
  ) {
    this.companyName = localStorage.getItem('currentLang') === 'ar' && this.tenantConfigService.tenant.companyNameAr ? this.tenantConfigService.tenant.companyNameAr : this.tenantConfigService.tenant.companyName;
    this.homeMobileAppSplashImageUrl=this.tenantConfigService.tenant.homeMobileAppSplashImageUrl;
    this.coloredLogoUrl=this.tenantConfigService.tenant.coloredLogoUrl;
    this.emptyStateImageUrl=this.tenantConfigService.tenant.emptyStateImageUrl;
    this.opportunityTheme=this.tenantConfigService.tenant.opportunityTheme;
    this.tenantId=this.tenantConfigService.tenant.tenantId;
    this.googlePlayDownloadUrl=this.tenantConfigService.tenant.googlePlayDownloadUrl;
    this.appleStoreDownloadUrl=this.tenantConfigService.tenant.appleStoreDownloadUrl;
  }

  ngOnInit() {
    this.getOpportunities();
  }

  getOpportunities() {
    this.fundDataService.GetAllOpportunities(this.filterFundStatus, this.filterFundType, 1, 6).subscribe({
      next: (res) => {
        this.opportunities = res.resource.items.filter(item => !item.isCompleted && item.soldPercentage < 100);
      },
      error: (err) => {
        this.notificationService.error(err.message!)
      }
    });
  }

  filter(fundType: EFundStatus, fundTypeEnum?: FundTypeEnum) {
    this.filterFundType = fundTypeEnum;
    this.filterFundStatus = fundType;
    this.getOpportunities();
  }
  redirectToLogin() {
    this.router.navigate(['authentication/login']);
  }
  openFilterDialog(){
    this.dialogService.open(this.filterDialogRef, {
      width: '600px',
      height: '100vh',
      maxHeight: '100vh',
    });

  }
  closeFilterDialog(){
    this.dialogService.closeAll();
  }
 setFilter(fundStatus: EFundStatus, fundType?: FundTypeEnum) {
  this.filterFundStatus = fundStatus;
  this.filterFundType = fundType;
 }
  applyFilter(){
    this.closeFilterDialog();
    this.filter(this.filterFundStatus,this.filterFundType);
  }
}
